module.exports = __webpack_public_path__ + "img/country_beige_ba_list.813fead6.jpg";